import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Select } from '@/components/ui/Select';
import { useCreateAnnouncement } from '@/hooks/useAdminCommunications';
import { announcementSchema, type AnnouncementFormData } from '@/schemas/communication.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

interface AnnouncementEditorProps {
  onSuccess?: () => void;
}

export function AnnouncementEditor({ onSuccess }: AnnouncementEditorProps) {
  const create = useCreateAnnouncement();
  const { register, handleSubmit, formState: { errors } } = useForm<AnnouncementFormData>({
    resolver: zodResolver(announcementSchema),
    defaultValues: { type: 'info', isActive: true },
  });

  const onSubmit = (data: AnnouncementFormData) => {
    create.mutate(data, { onSuccess: () => onSuccess?.() });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Input label="Titre" error={errors.title?.message} {...register('title')} />
      <div>
        <label className="mb-1.5 block text-sm font-medium text-neutral-700 dark:text-neutral-300">Contenu</label>
        <textarea
          className="w-full rounded-lg border border-neutral-300 dark:border-neutral-700 bg-white dark:bg-neutral-800 px-3 py-2 text-sm text-neutral-900 dark:text-neutral-100 placeholder:text-neutral-400 dark:placeholder:text-neutral-500 focus:border-primary-500 focus:outline-none min-h-[80px]"
          {...register('content')}
        />
        {errors.content && <p className="mt-1 text-xs text-danger-500">{errors.content.message}</p>}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Select label="Type" options={[
          { value: 'info', label: 'Information' },
          { value: 'feature', label: 'Nouveauté' },
          { value: 'update', label: 'Mise à jour' },
          { value: 'warning', label: 'Avertissement' },
        ]} {...register('type')} />
        <Input label="Date de début" type="datetime-local" error={errors.startsAt?.message} {...register('startsAt')} />
      </div>
      <Button type="submit" loading={create.isPending}>Publier</Button>
    </form>
  );
}
